import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import MainAbout from '@/components/main/about/index'
import MainNewsIndex from '@/components/main/news/index'
import MainNewsDetail from '@/components/main/news/detail'
import MainNoticeIndex from '@/components/main/notice/index'
import MainNoticeDetail from '@/components/main/notice/detail'
import AeduIndex from '@/components/aedu/index/index'
import AeduProfessionalIndex from '@/components/aedu/professional/index'
import AeduProfessionalDetail from '@/components/aedu/professional/detail'
import AeduNoticeIndex from '@/components/aedu/notice/index'
import AeduNoticeDetail from '@/components/aedu/notice/detail'
import AeduEninfoIndex from '@/components/aedu/eninfo/index'
import AeduEninfoDetail from '@/components/aedu/eninfo/detail'
import AeduPolicyIndex from '@/components/aedu/policy/index'
import AeduPolicyDetail from '@/components/aedu/policy/detail'
import TrainIndex from '@/components/train/index/index'
import TrainProjectIndex from '@/components/train/project/index'
import TrainProjectDetail from '@/components/train/project/detail'
import TrainProjectSign from '@/components/train/project/sign'
import TrainProjectSignUpTz from '@/components/train/project/signUpTz'
import TrainProjectPrint from '@/components/train/project/print'
import TrainTeachersIndex from '@/components/train/teachers/index'
import TrainTeachersDetail from '@/components/train/teachers/detail'
import TrainCalendarIndex from '@/components/train/calendar/index'
import TrainNoticeIndex from '@/components/train/notice/index'
import TrainNoticeDetail from '@/components/train/notice/detail'
import TrainInquiryIndex from '@/components/train/inquiry/index'
import TrainInquiryDetail from '@/components/train/inquiry/detail'
import TrainFormIndex from '@/components/train/form/index'
import TrainFormDetail from '@/components/train/form/detail'
import TrainPoliciesIndex from '@/components/train/policies/index'
import TrainPoliciesDetail from '@/components/train/policies/detail'
import TrainInfoIndex from '@/components/train/info/index'
import TrainInfoDetail from '@/components/train/info/detail'

import CeduIndex from '@/components/cedu/index/index'
import CeduSign from '@/components/cedu/index/sign'
import CeduSchoolIndex from '@/components/cedu/school/index'
import CeduSchoolDetail from '@/components/cedu/school/detail'
import CeduProfessionalIndex from '@/components/cedu/professional/index'
import CeduProfessionalDetail from '@/components/cedu/professional/detail'
import CeduDataIndex from '@/components/cedu/data/index'
import CeduDataDetail from '@/components/cedu/data/detail'
import CeduNoticeIndex from '@/components/cedu/notice/index'
import CeduNoticeDetail from '@/components/cedu/notice/detail'
import CeduPoliciesIndex from '@/components/cedu/policies/index'
import CeduPoliciesDetail from '@/components/cedu/policies/detail'
import CeduFormIndex from '@/components/cedu/form/index'
import CeduFormDetail from '@/components/cedu/form/detail'
import CeduAboutDetail from '@/components/cedu/about/detail'
import DeduIndex from '@/components/dedu/index/index'
import DeduSchoolIndex from '@/components/dedu/school/index'
import DeduSchoolDetail from '@/components/dedu/school/detail'
import DeduEnrollmentIndex from '@/components/dedu/enrollment/index'
import DeduEnrollmentDetail from '@/components/dedu/enrollment/detail'
import DeduProfessionalIndex from '@/components/dedu/professional/index'
import DeduProfessionalDetail from '@/components/dedu/professional/detail'
import DeduPolicyIndex from '@/components/dedu/policy/index'
import DeduPolicyDetail from '@/components/dedu/policy/detail'
import DeduStudentIndex from '@/components/dedu/student/index'
import DeduStudentDetail from '@/components/dedu/student/detail'
import DeduNoticeIndex from '@/components/dedu/notice/index'
import DeduNoticeDetail from '@/components/dedu/notice/detail'
import Search from '@/components/index/search'

import HeduIndex from '@/components/hedu/index/index'
import HeduSchoolIndex from '@/components/hedu/school/index'
import HeduSchoolDetail from '@/components/hedu/school/detail'
import HeduProfessionalIndex from '@/components/hedu/professional/index'
import HeduProfessionalDetail from '@/components/hedu/professional/detail'
import HeduDataIndex from '@/components/hedu/data/index'
import HeduDataDetail from '@/components/hedu/data/detail'
import HeduNoticeIndex from '@/components/hedu/notice/index'
import HeduNoticeDetail from '@/components/hedu/notice/detail'

import HeduPoliciesIndex from '@/components/hedu/policies/index'
import HeduPoliciesDetail from '@/components/hedu/policies/detail'
import HeduFormIndex from '@/components/hedu/form/index'
import HeduFormDetail from '@/components/hedu/form/detail'

import ZeduIndex from '@/components/zedu/index/index'
import ZeduBm from '@/components/zedu/index/bm'
import ZeduSearch from '@/components/zedu/index/search'
import ZeduNoticeDetail from '@/components/zedu/notice/detail'

import MobileTrainProjectSign from '@/components/mobile/train/project/sign'
import MobileTrainProjectSignUpTz from '@/components/mobile/train/project/signUpTz'
import MobileTrainProjectSignUp from '@/components/mobile/train/project/signUp'
import MobileTrainProjectSignWt from '@/components/mobile/train/project/signWt'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/front/dist/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      beforeEnter: (to, from, next) => {
        // document.title = '首页';
        next();
      }
    },
    {
      path: '/about',
      name: 'MainAbout',
      component: MainAbout,
      beforeEnter: (to, from, next) => {
        // document.title = '学院简介';
        next();
      },
    },
    {
      path: '/news/index',
      name: 'MainNewsIndex',
      component: MainNewsIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '新闻资讯';
        next();
      },
    },
    {
      path: '/news/detail',
      name: 'MainNewsDetail',
      component: MainNewsDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '资讯详情';
        next();
      }
    },
    {
      path: '/notice/index',
      name: 'MainNoticeIndex',
      component: MainNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '公告列表';
        next();
      }
    },
    {
      path: '/notice/detail',
      name: 'MainNoticeDetail',
      component: MainNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/aedu/index',
      name: 'AeduIndex',
      component: AeduIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '学历教育首页';
        next();
      }
    },
    {
      path: '/aedu/professional/index',
      name: 'AeduProfessionalIndex',
      component: AeduProfessionalIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专业介绍';
        next();
      }
    },
    {
      path: '/aedu/professional/detail',
      name: 'AeduProfessionalDetail',
      component: AeduProfessionalDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '专业详情';
        next();
      }
    },
    {
      path: '/aedu/notice/index',
      name: 'AeduNoticeIndex',
      component: AeduNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/aedu/notice/detail',
      name: 'AeduNoticeDetail',
      component: AeduNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '通知详情';
        next();
      }
    },
    {
      path: '/aedu/eninfo/index',
      name: 'AeduEninfoIndex',
      component: AeduEninfoIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '招生信息';
        next();
      }
    },
    {
      path: '/aedu/eninfo/detail',
      name: 'AeduEninfoDetail',
      component: AeduEninfoDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '招生详情';
        next();
      }
    },
    {
      path: '/aedu/policy/index',
      name: 'AeduPolicyIndex',
      component: AeduPolicyIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '政策文件';
        next();
      }
    },
    {
      path: '/aedu/policy/detail',
      name: 'AeduPolicyDetail',
      component: AeduPolicyDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '政策详情';
        next();
      }
    },
    {
      path: '/train/index',
      name: 'TrainIndex',
      component: TrainIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '培训与技能考证首页';
        next();
      }
    },
    {
      path: '/train/project/index',
      name: 'TrainProjectIndex',
      component: TrainProjectIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '培训项目';
        next();
      }
    },
    {
      path: '/train/project/detail',
      name: 'TrainProjectDetail',
      component: TrainProjectDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/train/project/sign',
      name: 'TrainProjectSign',
      component: TrainProjectSign,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/train/project/sign-up-tz',
      name: 'TrainProjectSignUpTz',
      component: TrainProjectSignUpTz,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/train/project/print',
      name: 'TrainProjectPrint',
      component: TrainProjectPrint,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    // {
    //   path: '/train/teachers/index',
    //   name: 'TrainTeachersIndex',
    //   component: TrainTeachersIndex,
    //   beforeEnter: (to, from, next) => {
    //     // document.title = '师资团队';
    //     next();
    //   }
    // },
    {
      path: '/train/teachers/detail',
      name: 'TrainTeachersDetail',
      component: TrainTeachersDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '教师详情';
        next();
      }
    },
    {
      path: '/train/calendar/index',
      name: 'TrainCalendarIndex',
      component: TrainCalendarIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '培训日历';
        next();
      }
    },
    {
      path: '/train/notice/index',
      name: 'TrainNoticeIndex',
      component: TrainNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/train/notice/detail',
      name: 'TrainNoticeDetail',
      component: TrainNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/train/inquiry/index',
      name: 'TrainInquiryIndex',
      component: TrainInquiryIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '培训咨询';
        next();
      }
    },
    {
      path: '/train/inquiry/detail',
      name: 'TrainInquiryDetail',
      component: TrainInquiryDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '咨询详情';
        next();
      }
    },
    {
      path: '/train/policies/index',
      name: 'TrainPoliciesIndex',
      component: TrainPoliciesIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/train/policies/detail',
      name: 'TrainPoliciesDetail',
      component: TrainPoliciesDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/train/form/index',
      name: 'TrainFormIndex',
      component: TrainFormIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/train/form/detail',
      name: 'TrainFormDetail',
      component: TrainFormDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/train/info/index',
      name: 'TrainInfoIndex',
      component: TrainInfoIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/train/info/detail',
      name: 'TrainInfoDetail',
      component: TrainInfoDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/cedu/index',
      name: 'CeduIndex',
      component: CeduIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专升本自考首页';
        next();
      }
    },
    {
      path: '/cedu/sign',
      name: 'CeduSign',
      component: CeduSign,
      beforeEnter: (to, from, next) => {
        // document.title = '专升本自考首页';
        next();
      }
    },
    {
      path: '/cedu/school/index',
      name: 'CeduSchoolIndex',
      component: CeduSchoolIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '主考院校';
        next();
      }
    },
    {
      path: '/cedu/school/detail',
      name: 'CeduSchoolDetail',
      component: CeduSchoolDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '院校详情';
        next();
      }
    },
    {
      path: '/cedu/professional/index',
      name: 'CeduProfessionalIndex',
      component: CeduProfessionalIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专业介绍';
        next();
      }
    },
    {
      path: '/cedu/professional/detail',
      name: 'CeduProfessionalDetail',
      component: CeduProfessionalDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '专业详情';
        next();
      }
    },
    {
      path: '/cedu/data/index',
      name: 'CeduDataIndex',
      component: CeduDataIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '自考资料';
        next();
      }
    },
    {
      path: '/cedu/data/detail',
      name: 'CeduDataDetail',
      component: CeduDataDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '资料详情';
        next();
      }
    },
    {
      path: '/cedu/notice/index',
      name: 'CeduNoticeIndex',
      component: CeduNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/cedu/notice/detail',
      name: 'CeduNoticeDetail',
      component: CeduNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/cedu/policies/index',
      name: 'CeduPoliciesIndex',
      component: CeduPoliciesIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/cedu/policies/detail',
      name: 'CeduPoliciesDetail',
      component: CeduPoliciesDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/cedu/form/index',
      name: 'CeduFormIndex',
      component: CeduFormIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/cedu/form/detail',
      name: 'CeduFormDetail',
      component: CeduFormDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },//CeduAboutDetail
    {
      path: '/cedu/about/detail',
      name: 'CeduAboutDetail',
      component: CeduAboutDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/dedu/index',
      name: 'DeduIndex',
      component: DeduIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '远程教育首页';
        next();
      }
    },
    {
      path: '/dedu/school/index',
      name: 'DeduSchoolIndex',
      component: DeduSchoolIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '走进网校';
        next();
      }
    },
    {
      path: '/dedu/school/detail',
      name: 'DeduSchoolDetail',
      component: DeduSchoolDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '网校详情';
        next();
      }
    },
    {
      path: '/dedu/enrollment/index',
      name: 'DeduEnrollmentIndex',
      component: DeduEnrollmentIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '走进网校';
        next();
      }
    },
    {
      path: '/dedu/enrollment/detail',
      name: 'DeduEnrollmentDetail',
      component: DeduEnrollmentDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '网校详情';
        next();
      }
    },
    {
      path: '/dedu/professional/index',
      name: 'DeduProfessionalIndex',
      component: DeduProfessionalIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专业介绍';
        next();
      }
    },
    {
      path: '/dedu/professional/detail',
      name: 'DeduProfessionalDetail',
      component: DeduProfessionalDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '专业详情';
        next();
      }
    },
    {
      path: '/dedu/policy/index',
      name: 'DeduPolicyIndex',
      component: DeduPolicyIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '政策文件';
        next();
      }
    },
    {
      path: '/dedu/policy/detail',
      name: 'DeduPolicyDetail',
      component: DeduPolicyDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '文件详情';
        next();
      }
    },
    {
      path: '/dedu/student/index',
      name: 'DeduStudentIndex',
      component: DeduStudentIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '招生简章';
        next();
      }
    },
    {
      path: '/dedu/student/detail',
      name: 'DeduStudentDetail',
      component: DeduStudentDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '招生详情';
        next();
      }
    },
    {
      path: '/dedu/notice/index',
      name: 'DeduNoticeIndex',
      component: DeduNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/dedu/notice/detail',
      name: 'DeduNoticeDetail',
      component: DeduNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/hedu/index',
      name: 'HeduIndex',
      component: HeduIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专升本自考首页';
        next();
      }
    },
    {
      path: '/hedu/school/index',
      name: 'HeduSchoolIndex',
      component: HeduSchoolIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '主考院校';
        next();
      }
    },
    {
      path: '/hedu/school/detail',
      name: 'HeduSchoolDetail',
      component: HeduSchoolDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '院校详情';
        next();
      }
    },
    {
      path: '/hedu/professional/index',
      name: 'HeduProfessionalIndex',
      component: HeduProfessionalIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '专业介绍';
        next();
      }
    },
    {
      path: '/hedu/professional/detail',
      name: 'HeduProfessionalDetail',
      component: HeduProfessionalDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '专业详情';
        next();
      }
    },
    {
      path: '/hedu/data/index',
      name: 'HeduDataIndex',
      component: HeduDataIndex,
      beforeEnter: (to, from, next) => {

        next();
      }
    },
    {
      path: '/hedu/data/detail',
      name: 'HeduDataDetail',
      component: HeduDataDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '资料详情';
        next();
      }
    },
    {
      path: '/hedu/notice/index',
      name: 'HeduNoticeIndex',
      component: HeduNoticeIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/hedu/notice/detail',
      name: 'HeduNoticeDetail',
      component: HeduNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/zedu/index',
      name: 'ZeduIndex',
      component: ZeduIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '全日制专升本首页';
        next();
      }
    },
    {
      path: '/zedu/bm',
      name: 'ZeduBm',
      component: ZeduBm,
      beforeEnter: (to, from, next) => {
        // document.title = '全日制专升本报名';
        next();
      }
    },
    {
      path: '/zedu/search',
      name: 'ZeduSearch',
      component: ZeduSearch,
      beforeEnter: (to, from, next) => {
        // document.title = '全日制专升本报名';
        next();
      }
    },
    {
      path: '/zedu/notice/detail',
      name: 'ZeduNoticeDetail',
      component: ZeduNoticeDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '全日制专升本报名';
        next();
      }
    },

    {
      path: '/hedu/policies/index',
      name: 'HeduPoliciesIndex',
      component: HeduPoliciesIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/hedu/policies/detail',
      name: 'HeduPoliciesDetail',
      component: HeduPoliciesDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/hedu/form/index',
      name: 'HeduFormIndex',
      component: HeduFormIndex,
      beforeEnter: (to, from, next) => {
        // document.title = '通知公告';
        next();
      }
    },
    {
      path: '/hedu/form/detail',
      name: 'HeduFormDetail',
      component: HeduFormDetail,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      beforeEnter: (to, from, next) => {
        // document.title = '公告详情';
        next();
      }
    },
    {
      path: '/mobile/train/project/sign',
      name: 'MobileTrainProjectSign',
      component: MobileTrainProjectSign,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/mobile/train/project/sign-up-tz',
      name: 'MobileTrainProjectSignUpTz',
      component: MobileTrainProjectSignUpTz,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/mobile/train/project/sign-up',
      name: 'MobileTrainProjectSignUp',
      component: MobileTrainProjectSignUp,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
    {
      path: '/mobile/train/project/sign-wt',
      name: 'MobileTrainProjectSignWt',
      component: MobileTrainProjectSignWt,
      beforeEnter: (to, from, next) => {
        // document.title = '项目详情';
        next();
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

//动态修改文档名称
router.beforeEach(function (to, from, next) {
  if (!to.path.includes('/mobile/')) { //不是移动端
    //document.title = 'sss'
    Vue.prototype.$request.getSims('site/school-info', {}, response => {
      if (response.status == 200 && response.data.code == 200) {
        let data = response.data.data
        document.title = data.site_name
        next()
      }
    }, error => {
      //console.log(error)
      next()
    })
  } else
    next()

})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js